// GF.ts
export const GF: any = {
  checkValueItem: (vi: any) => {
    if (!vi) return;

    if (vi.isRequired && (vi.value == null || vi.value == "")) {
      vi.hasError = true;
      vi.error = vi.requiredError;
      return;
    }

    vi.hasError = false;
    vi.error = "";
  },
  setAlertError: (alert: any, message: String) => {
    if (!alert) return;

    //clear alert first
    alert.hasError = false;
    alert.error = "";
    alert.hasWarning = false;
    alert.warning = "";
    alert.hasSuccess = false;
    alert.success = "";
    alert.hasInfo = false;
    alert.info = "";

    if (message != "") {
      alert.error = message;
      alert.hasError = true;
    }
    alert.hasAny = alert.hasInfo || alert.hasError || alert.hasSuccess || alert.hasWarning;
    alert.isError = alert.hasError || alert.hasWarning;
  },
  setAlertWarning: (alert: any, message: String) => {
    if (!alert) return;

    //clear alert first
    alert.hasError = false;
    alert.error = "";
    alert.hasWarning = false;
    alert.warning = "";
    alert.hasSuccess = false;
    alert.success = "";
    alert.hasInfo = false;
    alert.info = "";

    if (message != "") {
      alert.warning = message;
      alert.hasWarning = true;
    }
    alert.hasAny = alert.hasInfo || alert.hasError || alert.hasSuccess || alert.hasWarning;
    alert.isError = alert.hasError || alert.hasWarning;
  },
  clearAlert: (alert: any) => {
    if (!alert) return;

    alert.hasAny = false;
    alert.isError = false;

    alert.hasError = false;
    alert.error = "";

    alert.hasWarning = false;
    alert.warning = "";

    alert.hasSuccess = false;
    alert.success = "";

    alert.hasInfo = false;
    alert.info = "";
  }
}
